import { connect } from 'react-redux';
//
import AdditionalBatnas from 'components/formula-entry/modals/additional-batnas/additional-batnas';
import { IStoreState } from 'store';
import { cancelFormulaEdit, updateMarkerList } from 'store/formula-entry/actions';
import { updateProductField } from 'store/deal-edit/actions';
import { setLoading } from 'store/loading/actions';
import { getDealEvaluation } from 'store/deal-evaluation/actions';
import { IFormulaEntryState } from 'store/formula-entry/types';
import { IDeal } from 'store/deals/types';
import { ELoadingType } from 'store/loading/types';
import { ICostFormulaGroup } from 'store/cost-formulas/types';
import { getAllMarkersList } from '../formula-list/selectors/selectors';
import { TConcatArraysReturnType } from '../types';

export interface IAdditionalBatnasModalStateProps {
  dealEdit: IDeal;
  formulaEntry: IFormulaEntryState;
  availableCostFormulaGroups?: ICostFormulaGroup[];
  allTypesMarkerList: TConcatArraysReturnType[];
}

export interface IAdditionalBatnasModalDispatchProps {
  cancelFormulaEdit: () => void;
  getDealEvaluation: () => void;
  setLoading: (loading: ELoadingType) => void;
  updateProductField: Function;
  updateMarkerList: Function;
}

export type TAdditionalBatnasModalProps = IAdditionalBatnasModalDispatchProps & IAdditionalBatnasModalStateProps;

const mapStateToProps = (state: IStoreState) => {
  const { formulaEntry, dealEdit } = state;
  return {
    dealEdit,
    formulaEntry,
    allTypesMarkerList: getAllMarkersList(state),
  };
};

const mapDispatchToProps = {
  cancelFormulaEdit,
  getDealEvaluation,
  setLoading,
  updateProductField,
  updateMarkerList,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalBatnas);
